export default __webpack_public_path__ + "static/media/CLD_DK.5f63fa95.png";